var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 5.66663H4.83333C4.3731 5.66663 4 6.03972 4 6.49996V21.5C4 21.9602 4.3731 22.3333 4.83333 22.3333H23.1667C23.6269 22.3333 24 21.9602 24 21.5V6.49996C24 6.03972 23.6269 5.66663 23.1667 5.66663Z",
    stroke: "#2D3D95",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.1666L9.24406 12.9225C9.32144 12.8451 9.41331 12.7838 9.51441 12.7419C9.61552 12.7 9.72388 12.6784 9.83332 12.6784C9.94275 12.6784 10.0511 12.7 10.1522 12.7419C10.2533 12.7838 10.3452 12.8451 10.4226 12.9225L15.0774 17.5773C15.1548 17.6547 15.2466 17.7161 15.3477 17.758C15.4489 17.7999 15.5572 17.8214 15.6667 17.8214C15.7761 17.8214 15.8844 17.7999 15.9856 17.758C16.0867 17.7161 16.1785 17.6547 16.2559 17.5773L18.4107 15.4225C18.4881 15.3451 18.58 15.2838 18.6811 15.2419C18.7822 15.2 18.8905 15.1784 19 15.1784C19.1094 15.1784 19.2178 15.2 19.3189 15.2419C19.42 15.2838 19.5119 15.3451 19.5892 15.4225L24 19.8333",
    stroke: "#2D3D95",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.917 12.3333C17.6073 12.3333 18.167 11.7736 18.167 11.0833C18.167 10.3929 17.6073 9.83329 16.917 9.83329C16.2266 9.83329 15.667 10.3929 15.667 11.0833C15.667 11.7736 16.2266 12.3333 16.917 12.3333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/gallery-icon.478542952e04a2f54587198cc194eb6a.svg";
export { ForwardRef as ReactComponent };